import React from 'react'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import { Container, Icon, Heading, Message } from './styles'

const FormSubmissionError = ({ isVisible = false, heading, children }) => {
  return isVisible ? (
    <Container>
      <Icon icon={faExclamationTriangle} />
      {heading && <Heading>{heading}</Heading>}
      {children && <Message>{children}</Message>}
    </Container>
  ) : null
}

export default FormSubmissionError
